import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, HammerIcon, SparklesIcon } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Consultation & Styling',
  description: 'Choose your door style and finish with our design experts in-home or via remote photo analysis.',
  icon: SearchIcon
}, {
  number: '02',
  title: 'Precise Clean Cut Installation',
  description: 'Our technicians apply high-pressure veneers and install custom-made doors with zero structural mess.',
  icon: HammerIcon
}, {
  number: '03',
  title: 'Your Brand New Kitchen',
  description: 'In just 1-2 days, enjoy a premium kitchen transformation that looks and feels completely new.',
  icon: SparklesIcon
}];
export function ProcessGrid() {
  return <section className="py-24 px-6 bg-alabaster overflow-hidden" data-id="element-132">
      <div className="max-w-7xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-134">
          <div className="max-w-2xl" data-id="element-135">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-136">
              A Friction-Free Journey
            </h2>
            <p className="text-charcoal/60" data-id="element-137">
              We've perfected the 48-hour transformation. No demolition, no
              dust, just results.
            </p>
          </div>
          <div className="border-3 border-espresso text-espresso px-6 py-3 font-bold uppercase tracking-widest text-xs" data-id="element-138">
            1-to-2 Day Completion
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-3 border-charcoal" data-id="element-139">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className={`p-8 md:p-12 bg-white flex flex-col gap-8 group hover:bg-charcoal transition-colors duration-500 ${idx !== steps.length - 1 ? 'md:border-r-3 border-charcoal' : ''} ${idx !== 0 ? 'border-t-3 md:border-t-0 border-charcoal' : ''}`} data-id="element-140">
              <div className="flex justify-between items-start" data-id="element-141">
                <span className="text-5xl font-serif italic text-espresso group-hover:text-alabaster transition-colors" data-id="element-142">
                  {step.number}
                </span>
                <step.icon className="w-8 h-8 text-charcoal group-hover:text-espresso transition-colors" data-id="element-143" />
              </div>
              <div data-id="element-144">
                <h3 className="text-2xl font-bold mb-4 group-hover:text-alabaster transition-colors" data-id="element-145">
                  {step.title}
                </h3>
                <p className="text-charcoal/60 group-hover:text-alabaster/60 transition-colors leading-relaxed" data-id="element-146">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}